module.exports = __webpack_public_path__ + "img/2_bg_noatm.6e944bf1.png";